export enum Models {
  Brand = 'BrandModel',
  Brands = 'BrandsModel',
  Partner = 'PartnerModel',
  Partners = 'PartnersModel',
  User = 'UserModel',
  Users = 'UsersModel',
  Tariff = 'TariffModel',
  Tariffs = 'TariffsModel',
  SimCard = 'SimCardModel',
  Customer = 'CustomerModel',
  Customers = 'CustomersModel',
  Device = 'DeviceModel',
  Devices = 'DevicesModel',
  LastPacket = 'LastPacketModel',
  StatisticsInfo = 'StatisticsInfoModel',
  TripsDailyInfo = 'TripsDailyInfoModel',
  DeviceSendCommandResponse = 'DeviceSendCommandResponseModel',
  Vehicle = 'VehicleModel',
  Vehicles = 'VehiclesModel',
  CommandLogs = 'CommandLogsModel',
  DeviceLogHistory = 'DeviceLogHistoryModel',
  DeviceJournal = 'DeviceJournal',
  Ownership = 'OwnershipModel',
  Ownerships = 'OwnershipsModel',
  Subscription = 'SubscriptionModel',
  Subscriptions = 'SubscriptionsModel',
  Story = 'StoryModel',
  Stories = 'StoriesModel',
  Color = 'ColorModel',
  Colors = 'ColorsModel',
  Configuration = 'ConfigurationModel',
  Configurations = 'ConfigurationsModel',
  Equipment = 'EquipmentModel',
  Equipments = 'EquipmentsModel',
  Generation = 'GenerationModel',
  Generations = 'GenerationsModel',
  Model = 'ModelModel',
  Models = 'ModelsModel',
  GenerationColor = 'GenerationColorModel',
  GenerationColors = 'GenerationColorsModel',
  EventsHistory = 'EventsHistoryModel',
  Glossary = 'GlossaryModel',
  Glossaries = 'GlossariesModel',
  All = 'all',
  Notification = 'NotificationModel',
  Notifications = 'NotificationsModel',
  NotificationTemplate = 'NotificationTemplateModel',
  NotificationTemplates = 'NotificationTemplatesModel',
  City = 'CityModel',
  Cities = 'CitiesModel',
  Locale = 'LocaleModel',
  Locales = 'LocalesModel',
  StoryPageView = 'StoryPageViewModel',
  StoryPageViews = 'StoryPageViewsModel',
  Ticket = 'TicketModel',
  Tickets = 'TicketsModel',
  BatchFirmwareUpdate = 'BatchFirmwareUpdateModel',
  Report = 'Report',
  Reports = 'Reports',
  Facility = 'FacilityModel',
  Facilities = 'FacilitiesModel',
  FacilityType = 'FacilityTypeModel',
  FacilityTypes = 'FacilityTypesModel',
  Provider = 'ProviderModel',
  Providers = 'ProvidersModel',
}
